"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ImplementationGuide_Definition = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_ImplementationGuide_Grouping_1 = require("./RTTI_ImplementationGuide_Grouping");
var RTTI_ImplementationGuide_Resource_1 = require("./RTTI_ImplementationGuide_Resource");
var RTTI_ImplementationGuide_Page_1 = require("./RTTI_ImplementationGuide_Page");
var RTTI_ImplementationGuide_Parameter_1 = require("./RTTI_ImplementationGuide_Parameter");
var RTTI_ImplementationGuide_Template_1 = require("./RTTI_ImplementationGuide_Template");
exports.RTTI_ImplementationGuide_Definition = t.recursion('IImplementationGuide_Definition', function () {
    return t.intersection([
        t.type({
            resource: t.array(RTTI_ImplementationGuide_Resource_1.RTTI_ImplementationGuide_Resource)
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            grouping: t.array(RTTI_ImplementationGuide_Grouping_1.RTTI_ImplementationGuide_Grouping),
            page: RTTI_ImplementationGuide_Page_1.RTTI_ImplementationGuide_Page,
            parameter: t.array(RTTI_ImplementationGuide_Parameter_1.RTTI_ImplementationGuide_Parameter),
            template: t.array(RTTI_ImplementationGuide_Template_1.RTTI_ImplementationGuide_Template)
        })
    ]);
});
//# sourceMappingURL=RTTI_ImplementationGuide_Definition.js.map